import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";

const FilesCounterTitle = () => {
  const { getTextByKey } = useContent();
  const { uploaderGetFiles, getSize } = useUploader();

  const quantity = uploaderGetFiles()?.length;
  const viewSize = bytesToDisplayHelper(getSize());

  return quantity > 0 ? (
    <div className="files-counter-title">
      {getTextByKey("files-selected")}
      {` ${quantity} ${getTextByKey("files")} (${viewSize.size} ${
        viewSize.type
      })`}
    </div>
  ) : null;
};
export default FilesCounterTitle;
